import React from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useSelector } from "react-redux";

const UserLogin: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { initialized, keycloak } = useKeycloak();
  const reduxState = useSelector((state: any) => state);

  React.useEffect(() => {
    const uniqueId = keycloak.clientId;

    const loginCount = localStorage.getItem(`${uniqueId}-loginCount`);

    if (loginCount === null) {
      localStorage.setItem(`${uniqueId}-loginCount`, "1");
    } else {
      localStorage.setItem(
        `${uniqueId}-loginCount`,
        `${Number(loginCount) + 1}`
      );
    }
  }, [initialized, keycloak, reduxState]);

  return <>{children}</>;
};

export default UserLogin;
